import { createUseStyles } from 'react-jss';

const useMainStyles = createUseStyles(() => ({
  Main: {
    maxWidth: 1400,
    margin: [0, 'auto'],
  },
}));

export default useMainStyles;
